module.exports = __webpack_public_path__ + "img/26bd.a18c5c8.svg";